import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Provide() {
  const qs = require("qs");
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const getItem = (key) => {
    const item = localStorage.getItem(key);
    if (!item) navigate("/login");
    else return localStorage.getItem(key);
  };

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const goPage = (path) => {
    navigate(path);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setData(data.map((row) => {
    //   if (row.name === name) {
    //     row.value = value;
    //   }
    //   return row;
    // }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = setData();
    console.log(e);
    // axios.post("/api/v1/users", data);
  };

  // 페이지 렌더링 후 가장 처음 호출되는 함수
  useEffect(
    () => {
      if (!localStorage.getItem("token")) goPage("/login");
      else {
        axios
          .post(
            `${window.location.protocol}//${window.location.hostname}:3001/check`,
            qs.stringify({
              token: localStorage.getItem("token"),
            })
          )
          .then((res) => {
            if (res.data.expired) {
              localStorage.removeItem("token");
              goPage("/login");
            }
          })
          .catch();
      }
    },
    // 페이지 호출 후 처음 한번만 호출될 수 있도록 [] 추가
    []
  );

  return (
    <div className="App">
      <button type="button" onClick={() => goPage("/")}>
        돌아가기
      </button>
      <button type="button" onClick={logout}>
        로그아웃
      </button>
      <header className="App-header">
        <h2>상품공급 단품등록</h2>
        <form onSubmit={handleSubmit}>
          <table>
            <tr>
              <th>상품코드</th>
              <td>
                <input
                  type="text"
                  id="commodityCode"
                  value=""
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>상품명</th>
              <td>
                <input type="text" id="name" value="" onChange={handleChange} />
              </td>
            </tr>
            <tr>
              <th>공급가</th>
              <td>
                <input
                  type="number"
                  id="wholesalePrice"
                  value="0"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>소비자가</th>
              <td>
                <input
                  type="number"
                  id="retailPrice"
                  value="0"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>소비자준수가</th>
              <td>
                <input
                  type="number"
                  id="recommendedRetailPrice"
                  placeholder="없을시 비워주세요"
                  value=""
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>할인율</th>
              <td>
                <input
                  type="number"
                  id="discountRate"
                  value="0"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>배송타입</th>
              <td>
                <input
                  type="radio"
                  name="deliveryType"
                  value="P"
                  checked="{true}"
                  onChange={handleChange}
                />
                선결제
                <input
                  type="radio"
                  name="deliveryType"
                  value="C"
                  onChange={handleChange}
                />
                착불
                <input
                  type="radio"
                  name="deliveryType"
                  value="F"
                  onChange={handleChange}
                />
                무료
              </td>
            </tr>
            <tr>
              <th>배송료</th>
              <td>
                <input
                  type="number"
                  id="deliveryFee"
                  value="3000"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>재고</th>
              <td>
                <input
                  type="number"
                  id="stock"
                  value="999"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>최소구매수량</th>
              <td>
                <input
                  type="number"
                  id="minPurchaseQuantity"
                  value="1"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>최대구매수량</th>
              <td>
                <input
                  type="number"
                  id="maxPurchaseQuantity"
                  placeholder="없을시 비워주세요"
                  value=""
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>썸네일</th>
              <td>
                <input type="button" value="저장" />
              </td>
            </tr>
            <tr>
              <th>상세정보</th>
              <td>
                <textarea
                  id="detailContent"
                  placeholder="html 형식 기재"
                  value=""
                  rows="5"
                  cols="33"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr>
              <th>과세여부</th>
              <td>
                <input
                  type="radio"
                  name="taxation"
                  value="Y"
                  checked="{true}"
                  onChange={handleChange}
                />
                과세
                <input
                  type="radio"
                  name="taxation"
                  value="N"
                  onChange={handleChange}
                />
                비과세
              </td>
            </tr>
          </table>
          <button type="submit">등록</button>
        </form>
      </header>
    </div>
  );
}

export default Provide;
